import React from "react";
import { getBackgroundColor } from "../../../../../utils/statusUtils";

const TimeTable = ({shift}: any) => {
    const shiftStyle = {
        backgroundColor: getBackgroundColor(shift.shiftStatus)
    };

    return (
        <div className="time-table">
            <div className="time-table-header">START TIME</div>
            <div className="time-table-header">FINISH TIME</div>
            <div className="time-table-header">HOURS</div>
            <div className="time-table-header">JOB NUMBER</div>
            <div className="time-table-header" >LABOUR ORDER NR</div>
            <div className="time-table-header">INVOICE</div>
            <div className="time-table-data" style={shiftStyle}>
                {shift.startTime}
            </div>
            <div className="time-table-data" style={shiftStyle}>
                {shift.endTime}
            </div>
            <div className="time-table-data" style={shiftStyle}>
                {shift.hours}
            </div>
            <div className="time-table-data" style={{...shiftStyle, fontSize: 13}}>
                {shift.jobNumber}
            </div>
            <div className="time-table-data" style={shiftStyle}>
                {shift.labourOrderNR}
            </div>
            <div className="time-table-data" style={shiftStyle}>
                {shift.invoice}
            </div>
        </div>
    )
}

export default TimeTable;
